const gatecheckDemos = [
  {
    contractorSlug: "ashgrove-passive",
    projectSlug: "queensway-house",
    record: {
      brand: "Layerbound",
      badge: "Research-backed demo",
      contractorName: "Ashgrove Passive Ltd",
      contractorShortName: "Ashgrove",
      sector: "Passive fire contractor",
      projectName: "Queensway House",
      projectSubtitle: "Passive Fire Tender",
      opportunitySummary:
        "Occupied remediation package covering compartmentation, firestopping, and loft remediation under a housing authority tender.",
      lastUpdated: "2026-08-11T14:30:00Z",
      decision: {
        status: "HOLD",
        recommendation: "Resolve the items below before estimating starts.",
        rationale:
          "The opportunity is commercially viable, but current evidence does not yet support a clean pre-pricing handoff.",
      },
      decisionHistory: [
        {
          date: "2026-08-07T09:15:00Z",
          state: "HOLD",
          owner: "Commercial",
          note: "Initial gate created after tender intake. Insurance and access assumptions flagged immediately.",
        },
        {
          date: "2026-08-09T15:40:00Z",
          state: "HOLD",
          owner: "Compliance",
          note: "Capability pack reviewed. Named operative evidence still missing for submission confidence.",
        },
      ],
      tenderMeta: {
        deadline: "2026-08-22",
        client: "Northborough Housing Authority",
        estimatedValue: "GBP 1.8m - 2.2m",
        geography: "Greater London",
        scope: "Compartmentation, firestopping, loft remediation",
      },
      executiveSummary: [
        { label: "Blockers", value: 2 },
        { label: "Evidence gaps", value: 1 },
        { label: "Scope decisions", value: 2 },
      ],
      nextActions: [
        {
          owner: "Commercial",
          action: "Confirm whether PI cover can be increased to the tender minimum before pricing resource is assigned.",
          dueLabel: "Before estimate kickoff",
        },
        {
          owner: "Operations",
          action: "Validate loft access assumptions and whether night access premiums are required.",
          dueLabel: "Client clarification window",
        },
        {
          owner: "Compliance",
          action: "Upload latest FIRAS evidence for operatives named in the submission pack.",
          dueLabel: "Submission draft",
        },
      ],
      findings: [
        {
          id: "pi-limit",
          type: "BLOCKER",
          severity: "High",
          title: "Professional indemnity limit below tender requirement",
          explanation: "Tender requires a higher indemnity limit than shown in current contractor evidence.",
          tenderRequirement: "Minimum professional indemnity cover of GBP 5m.",
          tenderSource: "Preliminaries.pdf",
          clauseReference: "p.81",
          contractorEvidence: "Current insurance schedule shows GBP 2m PI cover.",
          contractorEvidenceSource: "Insurance Schedule - valid until 31/03/2027",
          whyItMatters:
            "Current evidence does not demonstrate compliance with the commercial threshold required to proceed to pricing.",
          requiredAction: "Confirm whether increased cover is available before estimating.",
          owner: "Commercial",
          status: "Unresolved",
          confidence: "High",
          notes:
            "Broker previously indicated a top-up may be possible, but no written confirmation has been filed.",
          resolutionHistory: [
            {
              date: "2026-08-09",
              note: "Tender review flagged PI threshold mismatch during document intake.",
            },
          ],
        },
        {
          id: "firas-operatives",
          type: "EVIDENCE GAP",
          severity: "Medium",
          title: "Named operative competence evidence is incomplete",
          explanation: "The tender requests install competence evidence tied to the proposed site team.",
          tenderRequirement: "Submit third-party accreditation evidence for supervisors and installers assigned to the works.",
          tenderSource: "Quality Questions.docx",
          clauseReference: "QQ-14",
          contractorEvidence: "Company FIRAS certification provided, but named operative matrix is not attached.",
          contractorEvidenceSource: "Capability Pack v3",
          whyItMatters:
            "The contractor may still meet the requirement, but the current pack is too light to support a confident bid decision.",
          requiredAction: "Add the named operative matrix and current training records.",
          owner: "Compliance",
          status: "Unresolved",
          confidence: "Needs confirmation",
        },
        {
          id: "loft-access",
          type: "SCOPE DECISION",
          severity: "High",
          title: "Loft access and resident decant assumptions are commercially unclear",
          explanation: "The tender scope references loft works, but access methodology and resident interface assumptions are not fixed.",
          tenderRequirement: "Allow for all access requirements necessary to complete remediation works.",
          tenderSource: "Scope of Works.pdf",
          clauseReference: "4.2 / 6.1",
          contractorEvidence: "Estimator note assumes standard occupied access with no out-of-hours premium.",
          contractorEvidenceSource: "Estimator assumptions log",
          whyItMatters:
            "The wrong access assumption could materially distort labour duration, prelims, and risk pricing.",
          requiredAction: "Clarify access regime with client team before pricing is locked.",
          owner: "Operations",
          status: "Unresolved",
          confidence: "Medium",
        },
        {
          id: "qa-reporting",
          type: "CLEAR",
          severity: "Low",
          title: "Digital QA reporting requirement is covered",
          explanation: "The contractor already has live photo-based QA and closure reporting capability.",
          tenderRequirement: "Provide digital QA evidence and location-tagged completion records.",
          tenderSource: "Employer Requirements.pdf",
          clauseReference: "7.8",
          contractorEvidence: "Existing QA workflow supports tagged before/after evidence and exportable reports.",
          contractorEvidenceSource: "Ops process map / sample QA export",
          whyItMatters:
            "This requirement does not create additional pre-pricing risk.",
          requiredAction: "None at this stage.",
          owner: "Operations",
          status: "Resolved",
          confidence: "High",
        },
        {
          id: "night-works",
          type: "CLARIFICATION",
          severity: "Medium",
          title: "Out-of-hours access wording needs client clarification",
          explanation: "The docs imply potential evening access in communal areas but stop short of confirming programme expectations.",
          tenderRequirement: "Minimise resident disruption and maintain safe access at all times.",
          tenderSource: "Resident Liaison Appendix.pdf",
          clauseReference: "2.4",
          contractorEvidence: "No allowance for out-of-hours premium is shown in the current assumptions note.",
          contractorEvidenceSource: "Estimator assumptions log",
          whyItMatters:
            "If out-of-hours attendance is expected, prelims and labour rates should change before estimating proceeds.",
          requiredAction: "Submit a clarification question on access windows.",
          owner: "Commercial",
          status: "Accepted",
          confidence: "Medium",
        },
      ],
    },
  },
  {
    contractorSlug: "ashgrove-passive",
    projectSlug: "meridian-court",
    record: {
      brand: "Layerbound",
      badge: "Research-backed demo",
      contractorName: "Ashgrove Passive Ltd",
      contractorShortName: "Ashgrove",
      sector: "Passive fire contractor",
      projectName: "Meridian Court",
      projectSubtitle: "Fire Door Remediation Package",
      opportunitySummary:
        "Fire door remediation package where capability fit is good, but estimate assumptions still need to be made explicit.",
      lastUpdated: "2026-08-08T09:05:00Z",
      decision: {
        status: "CONDITIONAL",
        recommendation: "Proceed to estimating with clarifications tracked as pricing assumptions.",
        rationale:
          "The core capability fit is sound, but two commercial assumptions should be stated explicitly in the estimate cover.",
      },
      decisionHistory: [
        {
          date: "2026-08-05T12:20:00Z",
          state: "HOLD",
          owner: "Bid Lead",
          note: "Tender opened with competency evidence and access scope queries outstanding.",
        },
        {
          date: "2026-08-08T09:05:00Z",
          state: "CONDITIONAL",
          owner: "Commercial",
          note: "Gate advanced once capability fit was confirmed, subject to explicit pricing assumptions.",
        },
      ],
      tenderMeta: {
        deadline: "2026-08-19",
        client: "Crestbridge Property Services",
        estimatedValue: "GBP 620k - 780k",
        geography: "Birmingham",
        scope: "Fire door replacement and remedials",
      },
      executiveSummary: [
        { label: "Blockers", value: 0 },
        { label: "Evidence gaps", value: 1 },
        { label: "Scope decisions", value: 1 },
      ],
      nextActions: [
        {
          owner: "Estimator",
          action: "Carry access scaffold assumption as a priced exclusion until confirmed.",
          dueLabel: "Estimate issue",
        },
        {
          owner: "Compliance",
          action: "Attach latest manufacturer installation training evidence.",
          dueLabel: "Submission pack",
        },
      ],
      findings: [
        {
          id: "manufacturer-training",
          type: "EVIDENCE GAP",
          severity: "Medium",
          title: "Manufacturer-specific installer training certificates not yet attached",
          explanation: "Tender asks for product-specific competency evidence for the proposed doorset system.",
          tenderRequirement: "Evidence of manufacturer-approved installation competence for proposed system.",
          tenderSource: "Technical Response Schedule.xlsx",
          clauseReference: "TR-9",
          contractorEvidence: "General fire-door competence supplied, but manufacturer-specific certificates absent.",
          contractorEvidenceSource: "Submission checklist",
          whyItMatters:
            "This is unlikely to block capability, but it weakens confidence in compliance at tender stage.",
          requiredAction: "Add current training certificates from the nominated supplier.",
          owner: "Compliance",
          status: "Unresolved",
          confidence: "Medium",
        },
        {
          id: "access-scaffold",
          type: "SCOPE DECISION",
          severity: "Medium",
          title: "Communal stair access support should be priced as an assumption",
          explanation: "Tender drawings do not clearly confirm whether access scaffold is by principal contractor or package contractor.",
          tenderRequirement: "Allow all necessary access equipment to deliver the works safely.",
          tenderSource: "Drawings Register.pdf",
          clauseReference: "General Notes",
          contractorEvidence: "Current estimate note assumes scaffold by others.",
          contractorEvidenceSource: "Pre-price assumptions sheet",
          whyItMatters:
            "This is a manageable risk provided the estimate clearly states the access assumption.",
          requiredAction: "Issue estimate with scaffold responsibility stated as an assumption.",
          owner: "Estimator",
          status: "Accepted",
          confidence: "Medium",
        },
        {
          id: "regional-coverage",
          type: "CLEAR",
          severity: "Low",
          title: "Regional delivery footprint is aligned",
          explanation: "The contractor already delivers within the project geography with existing supervision coverage.",
          tenderRequirement: "Demonstrate operational capacity to deliver in the Midlands region.",
          tenderSource: "PQQ.pdf",
          clauseReference: "Section 5",
          contractorEvidence: "Current live projects and supervision map cover the same region.",
          contractorEvidenceSource: "Operations capacity tracker",
          whyItMatters:
            "No additional mobilisation risk needs to be priced at gatecheck stage.",
          requiredAction: "None.",
          owner: "Operations",
          status: "Resolved",
          confidence: "High",
        },
      ],
    },
  },
  {
    contractorSlug: "northern-compartmentation",
    projectSlug: "atlas-works",
    record: {
      brand: "Layerbound",
      badge: "Research-backed demo",
      contractorName: "Northern Compartmentation Group",
      contractorShortName: "NCG",
      sector: "Passive fire contractor",
      projectName: "Atlas Works",
      projectSubtitle: "Compartmentation Upgrade Programme",
      opportunitySummary:
        "Large compartmentation upgrade programme with aligned certification scope, insurance, and regional delivery capability.",
      lastUpdated: "2026-08-12T16:20:00Z",
      decision: {
        status: "CLEAR TO ESTIMATE",
        recommendation: "Proceed to estimating. Track only normal estimating assumptions.",
        rationale:
          "Capability, evidence, and commercial thresholds are aligned closely enough for pricing to begin without additional gatework.",
      },
      decisionHistory: [
        {
          date: "2026-08-10T10:00:00Z",
          state: "CONDITIONAL",
          owner: "Operations",
          note: "Gate opened with provisional review of opening-up quantities.",
        },
        {
          date: "2026-08-12T16:20:00Z",
          state: "CLEAR TO ESTIMATE",
          owner: "Commercial",
          note: "Insurance and accreditation checks cleared. Only normal estimating assumptions remain.",
        },
      ],
      tenderMeta: {
        deadline: "2026-08-28",
        client: "Harbourstone Build",
        estimatedValue: "GBP 2.6m - 3.1m",
        geography: "Manchester",
        scope: "Compartment walls, risers, service penetrations",
      },
      executiveSummary: [
        { label: "Blockers", value: 0 },
        { label: "Evidence gaps", value: 0 },
        { label: "Scope decisions", value: 1 },
      ],
      nextActions: [
        {
          owner: "Estimator",
          action: "Start take-off and retain standard exclusions on intrusive opening-up volumes.",
          dueLabel: "Immediate",
        },
      ],
      findings: [
        {
          id: "intrusive-openings",
          type: "SCOPE DECISION",
          severity: "Low",
          title: "Opening-up volumes should remain provisional",
          explanation: "The survey basis is strong, but concealed service penetrations may still move quantities.",
          tenderRequirement: "Allow for making good associated with surveyed defects and concealed penetrations.",
          tenderSource: "Survey Summary.pdf",
          clauseReference: "5.6",
          contractorEvidence: "Operations team has priced similar live frameworks with provisional opening-up allowances.",
          contractorEvidenceSource: "Framework benchmark pack",
          whyItMatters:
            "This is routine estimating management rather than a gate block.",
          requiredAction: "Carry as a normal provisional assumption.",
          owner: "Estimator",
          status: "Accepted",
          confidence: "High",
        },
        {
          id: "insurances",
          type: "CLEAR",
          severity: "Low",
          title: "Insurance thresholds are met",
          explanation: "Current policy schedule exceeds the tender minimums for PI and PL.",
          tenderRequirement: "Minimum GBP 5m PI and GBP 10m PL.",
          tenderSource: "Prelims.pdf",
          clauseReference: "8.4",
          contractorEvidence: "Policy schedule shows GBP 10m PI and GBP 10m PL.",
          contractorEvidenceSource: "Insurance Schedule - valid until 30/04/2027",
          whyItMatters:
            "Commercial qualification is already satisfied.",
          requiredAction: "None.",
          owner: "Commercial",
          status: "Resolved",
          confidence: "High",
        },
        {
          id: "accreditation",
          type: "CLEAR",
          severity: "Low",
          title: "Third-party accreditation aligns with tender ask",
          explanation: "Required passive fire accreditations are current and evidenced.",
          tenderRequirement: "Demonstrate current third-party accreditation relevant to firestopping works.",
          tenderSource: "PQQ.pdf",
          clauseReference: "Section 6",
          contractorEvidence: "Current FIRAS and ISO certification included in the pack.",
          contractorEvidenceSource: "Accreditation register",
          whyItMatters:
            "There is no capability block on proceeding to price.",
          requiredAction: "None.",
          owner: "Compliance",
          status: "Resolved",
          confidence: "High",
        },
      ],
    },
  },
  {
    contractorSlug: "fenland-fire",
    projectSlug: "riverside-towers",
    record: {
      brand: "Layerbound",
      badge: "Research-backed demo",
      contractorName: "Fenland Fire Protection",
      contractorShortName: "Fenland",
      sector: "Passive fire contractor",
      projectName: "Riverside Towers",
      projectSubtitle: "Occupied Remediation Lot",
      opportunitySummary:
        "Multi-block occupied remediation lot with principal contractor obligations and commercial terms outside the contractor's normal delivery model.",
      lastUpdated: "2026-08-10T11:45:00Z",
      decision: {
        status: "NO-BID",
        recommendation: "Do not move this opportunity into estimating under the current tender structure.",
        rationale:
          "Delivery risk and capability mismatch are material enough that pricing would create false momentum rather than a winnable bid.",
      },
      decisionHistory: [
        {
          date: "2026-08-08T14:10:00Z",
          state: "HOLD",
          owner: "Directors",
          note: "Initial review paused estimating pending commercial and operating model checks.",
        },
        {
          date: "2026-08-10T11:45:00Z",
          state: "NO-BID",
          owner: "Finance",
          note: "Bonding and principal contractor obligations confirmed as a hard mismatch.",
        },
      ],
      tenderMeta: {
        deadline: "2026-08-17",
        client: "Bayshore Living",
        estimatedValue: "GBP 4.4m - 5.0m",
        geography: "Bristol",
        scope: "Multi-block occupied remediation with principal contractor obligations",
      },
      executiveSummary: [
        { label: "Blockers", value: 2 },
        { label: "Evidence gaps", value: 0 },
        { label: "Scope decisions", value: 1 },
      ],
      nextActions: [
        {
          owner: "Bid Lead",
          action: "Issue no-bid decision with reasons captured for future target-fit review.",
          dueLabel: "Today",
        },
      ],
      findings: [
        {
          id: "principal-contractor",
          type: "BLOCKER",
          severity: "High",
          title: "Tender expects principal contractor-level management that the contractor does not currently provide",
          explanation: "The lot structure pushes resident liaison, traffic management, and multi-trade coordination onto the package contractor.",
          tenderRequirement: "Contractor to undertake principal contractor responsibilities for the occupied works zone.",
          tenderSource: "Contract Particulars.pdf",
          clauseReference: "CP-3 / CP-7",
          contractorEvidence: "Current operating model is specialist subcontract delivery, not PC-led delivery.",
          contractorEvidenceSource: "Operating model review",
          whyItMatters:
            "This is a structural mismatch rather than a missing document, making the opportunity unattractive at pre-pricing stage.",
          requiredAction: "Decline unless the lot structure changes materially.",
          owner: "Directors",
          status: "Unresolved",
          confidence: "High",
        },
        {
          id: "bonding",
          type: "BLOCKER",
          severity: "High",
          title: "Performance bond requirement exceeds current bonding appetite",
          explanation: "The bond percentage and parent-company support language sit outside the contractor's normal position.",
          tenderRequirement: "10 percent performance bond and group support undertaking.",
          tenderSource: "Prelims.pdf",
          clauseReference: "9.2",
          contractorEvidence: "Current finance policy does not support this bond position for a project of this size.",
          contractorEvidenceSource: "Finance limits note",
          whyItMatters:
            "Even if the technical scope fit were acceptable, the commercial structure would still make the bid weak.",
          requiredAction: "No-bid unless commercial terms are renegotiated.",
          owner: "Finance",
          status: "Unresolved",
          confidence: "High",
        },
        {
          id: "resident-liaison",
          type: "SCOPE DECISION",
          severity: "Medium",
          title: "Resident liaison staffing would need a separate delivery model",
          explanation: "The tender assumes an embedded resident team and daily access scheduling function.",
          tenderRequirement: "Provide dedicated resident liaison resource throughout delivery.",
          tenderSource: "Resident Charter.pdf",
          clauseReference: "1.2",
          contractorEvidence: "No in-house resident liaison team is currently budgeted or evidenced.",
          contractorEvidenceSource: "Ops structure chart",
          whyItMatters:
            "This increases delivery risk and overhead even before the wider PC mismatch is considered.",
          requiredAction: "Capture as no-bid rationale.",
          owner: "Operations",
          status: "Accepted",
          confidence: "High",
        },
      ],
    },
  },
  {
    contractorSlug: "citadel-compliance",
    projectSlug: "oakfield-estate",
    record: {
      brand: "Layerbound",
      badge: "Research-backed demo",
      contractorName: "Citadel Compliance Services",
      contractorShortName: "Citadel",
      sector: "Passive fire contractor",
      projectName: "Oakfield Estate",
      projectSubtitle: "Passive Fire Framework Mini-Competition",
      opportunitySummary:
        "Framework mini-competition with credible fit, but unreliable pricing basis because specialist and non-specialist remedials are bundled together.",
      lastUpdated: "2026-08-07T15:10:00Z",
      decision: {
        status: "HOLD",
        recommendation: "Pause pricing until framework call-off scope is unbundled.",
        rationale:
          "The contractor is framework-eligible, but the current mini-competition merges service lines in a way that obscures a reliable pricing basis.",
      },
      decisionHistory: [
        {
          date: "2026-08-06T09:00:00Z",
          state: "HOLD",
          owner: "Commercial",
          note: "Pricing schedule review opened. Measurement ambiguity identified immediately.",
        },
        {
          date: "2026-08-07T15:10:00Z",
          state: "HOLD",
          owner: "Estimator",
          note: "Gate remains on hold until the call-off structure separates passive fire from general remedials.",
        },
      ],
      tenderMeta: {
        deadline: "2026-08-21",
        client: "Eastland Council",
        estimatedValue: "GBP 950k - 1.3m",
        geography: "Leeds",
        scope: "Firestopping plus FRA remedial works",
      },
      executiveSummary: [
        { label: "Blockers", value: 1 },
        { label: "Evidence gaps", value: 0 },
        { label: "Scope decisions", value: 2 },
      ],
      nextActions: [
        {
          owner: "Commercial",
          action: "Request clarification on whether FRA remedials are measured separately from firestopping rates.",
          dueLabel: "Clarification deadline",
        },
        {
          owner: "Estimator",
          action: "Hold pricing resource until the measurement basis is confirmed.",
          dueLabel: "Immediate",
        },
      ],
      findings: [
        {
          id: "measurement-basis",
          type: "BLOCKER",
          severity: "High",
          title: "Measurement basis for mixed remedial items is not commercially reliable",
          explanation: "The mini-competition blends measured firestopping and open-ended remedial works without a clear separation rule.",
          tenderRequirement: "Submit fixed rates across the full remedial scope.",
          tenderSource: "Pricing Schedule.xlsx",
          clauseReference: "Lots A-C",
          contractorEvidence: "Internal review notes show multiple interpretations of the same bill items.",
          contractorEvidenceSource: "Commercial review workshop",
          whyItMatters:
            "A price issued against an unclear measurement basis is likely to be either uncompetitive or under-recovered.",
          requiredAction: "Pause estimating until the pricing schedule is clarified.",
          owner: "Commercial",
          status: "Unresolved",
          confidence: "High",
        },
        {
          id: "fra-scope",
          type: "SCOPE DECISION",
          severity: "Medium",
          title: "FRA remedial items may need exclusion or separate provisional rates",
          explanation: "Some items read like general building remedials rather than specialist passive fire scope.",
          tenderRequirement: "Contractor to cover associated remedial works identified during delivery.",
          tenderSource: "Scope Notes.pdf",
          clauseReference: "3.9",
          contractorEvidence: "Ops team prefers third-party support for non-specialist making good at scale.",
          contractorEvidenceSource: "Delivery model note",
          whyItMatters:
            "Without separation, the contractor could be pricing work outside its preferred delivery lane.",
          requiredAction: "Clarify whether non-specialist remedials can be excluded or provisioned.",
          owner: "Operations",
          status: "Unresolved",
          confidence: "Medium",
        },
        {
          id: "framework-status",
          type: "CLEAR",
          severity: "Low",
          title: "Framework eligibility is already satisfied",
          explanation: "The contractor is an eligible call-off participant with current standing documentation.",
          tenderRequirement: "Mini-competition open to named framework members only.",
          tenderSource: "Invitation to Tender.pdf",
          clauseReference: "1.1",
          contractorEvidence: "Framework award letter and standing documents are current.",
          contractorEvidenceSource: "Framework file",
          whyItMatters:
            "Eligibility is not a gating issue.",
          requiredAction: "None.",
          owner: "Bid Lead",
          status: "Resolved",
          confidence: "High",
        },
      ],
    },
  },
];

export function getGatecheckRecord(contractorSlug, projectSlug) {
  return (
    gatecheckDemos.find(
      (demo) =>
        demo.contractorSlug === contractorSlug && demo.projectSlug === projectSlug
    )?.record || null
  );
}

export function listGatecheckDemos() {
  return gatecheckDemos.map(({ contractorSlug, projectSlug, record }) => ({
    contractorSlug,
    projectSlug,
    contractorName: record.contractorName,
    projectName: record.projectName,
    status: record.decision.status,
  }));
}

export const GATECHECK_DECISION_STATES = [
  "HOLD",
  "CONDITIONAL",
  "CLEAR TO ESTIMATE",
  "NO-BID",
];
